import React from 'react'

import AccommodationSameRoomOptionTile from 'components/AccommodationKit/AccommodationSameRoom/AccommodationSameRoomOptionTile'
import AccommodationSameRoomOptionTileCTA from 'components/AccommodationKit/AccommodationSameRoom/AccommodationSameRoomOptionTileCTA'
import { AccommodationSameRoomOptionTileSubgrid } from 'components/AccommodationKit/AccommodationSameRoom/AccommodationSameRoomOptionTileSubgrid'

interface Props {
  'data-testid'?: string
  tileRef: React.Ref<HTMLDivElement>
  loyaltyUpgradeAppliedTier?: App.LoyaltyTier
  header: React.ReactNode
  details: React.ReactNode
  pricing: React.ReactNode
  actions: React.ReactNode
}

function PropertyRateOptionLayout({
  'data-testid': testId,
  tileRef,
  loyaltyUpgradeAppliedTier,
  header,
  details,
  pricing,
  actions,
}: Props) {
  return <AccommodationSameRoomOptionTileSubgrid>
    <AccommodationSameRoomOptionTile
      data-testid={testId}
      ref={tileRef}
      loyaltyUpgradeAppliedTier={loyaltyUpgradeAppliedTier}
    >
      {header}
      {details}
      {pricing}
      <AccommodationSameRoomOptionTileCTA>
        {actions}
      </AccommodationSameRoomOptionTileCTA>
    </AccommodationSameRoomOptionTile>
  </AccommodationSameRoomOptionTileSubgrid>
}

export default PropertyRateOptionLayout
